export const DEFAULT_BASE_URL = 'https://api.rango.exchange/'
export const DEFAULT_RANGO_API_KEY = 'c6381a79-2817-4602-83bf-6a641a409e32'
